import {Injectable} from '@angular/core';
import {ApiImplementation} from '../api/api-implementation.service';
import {ApiService} from '../api/api.service';
import {Paginator} from '../../models/paginator';
import {Entity} from '../../models/entity';
import {User} from '../../models/user';


@Injectable({
  providedIn: 'root',
})
export class EntitiesService extends ApiImplementation {

  protected base: string = 'v1/entities';
  protected primaryKey: string = 'id';

  constructor(protected api: ApiService) {
    super(api)
  }

  model(data?) {
    return new Entity(data);
  }

  paginator(data) {
    return new Paginator<Entity>(data);
  }


  public all(limit = 100, page = 1, options = null): Promise<Paginator<Entity>> {
    return super.all(limit, page, options) as Promise<Paginator<Entity>>;
  }

  public get(id: number) {
    return super.get(id) as Promise<Entity>;
  }

  public delete(entity: Entity) {
    return super.delete(entity);
  }

  public save(entity: Entity): Promise<Entity> {
    return super.save(entity) as Promise<Entity>;
  }

  public everything(category = null, minAge = 0, maxAge = 0): Promise<Array<Entity>> {
    let category_request = '';
    let age_request = '';

    if (category) {
      category_request = '&filter[category]=' + category;
    }

    if (minAge || maxAge) {
      age_request = '&filter[age]=' + maxAge + ',' + minAge;
    }

    return this.api.all(this.base, 1, [], age_request + category_request);
  }

  public users(entity_id: number): Promise<Array<User>> {
    const endpoint = 'v1/entities/' + entity_id + '/user-relations';
    return this.api.get(endpoint).then(data => {
      return data['data'];
    });
  }

}